import React from 'react';
import { useEntity, MissingAnnotationEmptyState } from '@backstage/plugin-catalog-react';
import { CodeCoveragePage } from './CodeCoveragePage/CodeCoveragePage.esm.js';

function isCodeCoverageAvailable(entity) {
  return Boolean(entity.metadata.annotations?.["backstage.io/code-coverage"]);
}
const Router = () => {
  const { entity } = useEntity();
  if (!isCodeCoverageAvailable(entity)) {
    return /* @__PURE__ */ React.createElement(MissingAnnotationEmptyState, { annotation: "backstage.io/code-coverage" });
  }
  return /* @__PURE__ */ React.createElement(CodeCoveragePage, null);
};

export { Router, isCodeCoverageAvailable };
//# sourceMappingURL=Router.esm.js.map
